import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=61a443aa&scoped=true&"
import script from "./Manage.vue?vue&type=script&lang=js&"
export * from "./Manage.vue?vue&type=script&lang=js&"
import style0 from "./Manage.vue?vue&type=style&index=0&id=61a443aa&prod&lang=scss&scoped=true&"
import style1 from "./Manage.vue?vue&type=style&index=1&id=61a443aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a443aa",
  null
  
)

export default component.exports